import dayjs, { Dayjs } from "dayjs";
import { REPORT_DATE_FORMAT_WITH_TIME } from "localConstants";
import { SearchFilterEnum } from "types/enums";

import { getPersistedTimeFilterValue } from "../atoms/timeFilterAtom";
import { FilterRule } from "../types/filter";

const formatDateTime = (d: Dayjs) => d.format(REPORT_DATE_FORMAT_WITH_TIME);

export const getDefaultCreatedAtFilter = (range: [Dayjs, Dayjs], dataIndex: string): FilterRule => {
    return {
        id: 0,
        dataIndex: dataIndex,
        operator: SearchFilterEnum.Between,
        value: `${formatDateTime(range[0])},${formatDateTime(range[1])}`,
        filterType: { type: "date", operators: [SearchFilterEnum.Between] },
        filterOptions: [],
    };
};

export const last30DaysCreatedAtStr = `${dayjs().subtract(30, "day").startOf("day").format(REPORT_DATE_FORMAT_WITH_TIME)},${dayjs().endOf("day").format(REPORT_DATE_FORMAT_WITH_TIME)}`;

export function useCreatedAtFilterValue() {
    const timeFilterValue = getPersistedTimeFilterValue();
    return timeFilterValue ?? last30DaysCreatedAtStr;
}
